import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';

import styles from './UpgradeURLCallout.scss';
import { ReactComponent as TKCircleAvatar } from './tk-circle-avatar.svg';
import LinkButton from '../../LinkButton';
import { TrackingContext } from '../../../TrackingContext';
import { purchaseDomainRoute } from '../../../helpers/routes';
import PurchaseDomainModal from '..';
import { Snackbar, SnackbarMessage } from '../../Snackbar';

export default function UpgradeURLCallout() {
  const history = useHistory();
  const { track } = useContext(TrackingContext);
  const [showPurchaseDomainModal, setShowPurchaseDomainModal] = useState(false);
  const [toastMessage, setToastMessage] = useState({} as SnackbarMessage);

  const goToCustomDomainBuy = () => {
    track('Custom WWS Domain Modal Opened');
    if (window.location.href.includes('preview')) {
      setShowPurchaseDomainModal(true);
    } else {
      history.push(purchaseDomainRoute);
    }
  };

  return (
    <>
      <Snackbar clearToastMessage={setToastMessage} toastMessage={toastMessage} />
      {showPurchaseDomainModal ? (
        <PurchaseDomainModal
          onClose={() => setShowPurchaseDomainModal(false)}
          setDomainPaymentToastMessage={setToastMessage}
        />
      ) : null}
      <div className={styles.container}>
        <div className={styles.upgradeUrlCalloutText}>Upgrade your URL</div>
        <div className={styles.levelUpContainer}>
          <div>
            Level up your website with your own easy-to-remember
            <LinkButton
              data-testid="custom-domain-callout"
              className={styles.customDomainLink}
              onClick={goToCustomDomainBuy}
            >
              custom domain.
            </LinkButton>
          </div>
          <div>
            <TKCircleAvatar />
          </div>
        </div>
      </div>
    </>
  );
}
